module.exports = __webpack_public_path__ + "img/banner-1.cfa4dc64.png";